import styled from 'styled-components'

const MutedText = styled.div.attrs((props) => {
    return {
        className: props.className + ` font-light text-gray-500/[.5]`,
    }
})``

export default MutedText
